import { Project } from "src/app/models/project";

export interface ProjectState{
    project: Project[];
}

export const initialProjectState: ProjectState = {
    project: []
}